<template>
  <div>
    <el-select
      v-model="audioOutputDeviceId"
      :popper-append-to-body="false"
      :no-data-text="$t('checkCamera.无设备')"
      class="check-select-device"
    >
      <el-option
        v-for="item in speakerDeviceList"
        :key="item.value"
        :label="item.label"
        :value="item.deviceId"
        @click.native="setAudioDevice(item.deviceId)"
      >
      </el-option>
    </el-select>
    <!-- 滑块 -->
    <div class="check-slider">
      <!-- <img :src="require('@/svg/speaker.svg')" width="20" /> -->
      <svg width="20px" height="20px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>编组</title>
          <desc>Created with Sketch.</desc>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="入会检测切图" transform="translate(-298.000000, -110.000000)" fill="#FFFFFF" class="more-chat"  fill-rule="nonzero">
                  <g id="扬声器" transform="translate(298.000000, 110.000000)">
                      <path d="M17.6321875,4.3059375 C17.189375,4.0053125 16.625,3.945625 16.1315625,4.1515625 L7.9221875,9.0328125 L3.62,9.0328125 C2.734375,9.0328125 2.0134375,9.76125 2.0134375,10.6559375 L2.0134375,20.964375 C2.0134375,21.85875 2.734375,22.5875 3.62,22.5875 L7.921875,22.5875 L16.0884375,27.4446875 L16.1353125,27.464375 C16.33125,27.5434375 16.5346875,27.5828125 16.7425,27.5828125 C17.0559375,27.5828125 17.369375,27.488125 17.635625,27.3059375 C18.079375,27.005 18.3453125,26.5 18.3446886,25.96 L18.3446886,5.651875 C18.34125,5.109375 18.07875,4.6065625 17.6321875,4.3059375 Z M16.35875,25.3621875 L8.6584375,20.7146875 L8.615625,20.695 C8.4234375,20.6159375 8.2196875,20.57625 8.008125,20.57625 L3.99625,20.57625 L3.99625,11.035625 L8.008125,11.035625 C8.2159375,11.035625 8.4196875,10.9959375 8.615625,10.916875 L16.3590625,6.249375 L16.3590625,25.3621875 L16.35875,25.3621875 Z M22.588125,9.705625 C22.403227,9.51761008 22.1505735,9.4117184 21.886875,9.4117184 C21.6231765,9.4117184 21.370523,9.51761008 21.185625,9.705625 C20.7978125,10.0975 20.7978125,10.7309375 21.185625,11.1228125 C23.661875,13.624375 23.661875,17.701875 21.185625,20.20375 C20.7978125,20.595625 20.7978125,21.2290625 21.185625,21.62125 C21.3778125,21.815 21.6321875,21.91375 21.886875,21.91375 C22.1415625,21.91375 22.39625,21.815 22.588125,21.62125 C25.83625,18.3353125 25.83625,12.99125 22.588125,9.705625 L22.588125,9.705625 Z M26.0671875,6.1665625 C25.8822895,5.97854758 25.629636,5.8726559 25.3659375,5.8726559 C25.102239,5.8726559 24.8495855,5.97854758 24.6646875,6.1665625 C24.2765625,6.5584375 24.2765625,7.1915625 24.6646875,7.5834375 C29.0721875,12.036875 29.0721875,19.285625 24.6646875,23.743125 C24.2765625,24.135 24.2765625,24.7684375 24.6646875,25.1603125 C24.8565625,25.3540625 25.11125,25.4528125 25.3659375,25.4528125 C25.6209375,25.4528125 25.8753125,25.3540625 26.0671875,25.1603125 C31.250625,19.923125 31.250625,11.4040625 26.0671875,6.1665625 L26.0671875,6.1665625 Z" id="形状"></path>
                  </g>
              </g>
          </g>
      </svg>
      <div class="check-slider-inner">
        <el-slider
          v-model="volume"
          :min="10"
          :max="100"
          :step="10"
          @change="changeVolume"
          class="check-slider-number"
        ></el-slider>
      </div>
      <span class="fontColor">{{ volume }}</span>
    </div>
    <!-- 测试 -->
    <el-button
      class="check-speaker-btn"
      v-if="!isPlaying"
      @click="changeAudioDestination"
      >{{ $t("check.testspeaker") }}</el-button
    >
    <el-button v-else class="check-speaker-btn active"></el-button>
  </div>
</template>

<script>
import { Slider } from "element-ui";
import Bus from "@/components/doc/bus";
export default {
  name: "checkSpeaker",
  data() {
    return {
      audioOutputDeviceId: null,
      speakerDeviceList: [], //扬声器列表
      volume: 40,
      audioEl: null,
      audioPlaySrc: require("@/file/audio.mp3"),
      isPlaying: false,
    };
  },
  components: {
    [Slider.name]: Slider,
  },
  created() {
    this.init();
    // navigator.mediaDevices.ondevicechange = () => {
    //   Bus.$emit('ondevicechange');
    //   this.init();
    // };
    Bus.$on('ondevicechange', () => {
      this.init();
    });
  },
  beforeDestroy() {
    Bus.$off('ondevicechange');
    this.stopAudioDestination();
  },
  methods: {
    async init() {
      let deviceInfos = await navigator.mediaDevices.enumerateDevices();
      console.log(deviceInfos, "deviceInfos");
      this.speakerDeviceList = deviceInfos.filter((d) => {
        return d.kind === "audiooutput" && d.deviceId;
      });
      if (this.speakerDeviceList.length == 0) {
        this.speakerDeviceList.push({
          label: this.$t("check.nospeakerdevice"),
          deviceId: null,
        });
        this.audioOutputDeviceId = null;
      } else {
        this.audioOutputDeviceId = this.speakerDeviceList[0].deviceId;
      }
      this.setAudioDevice();
    },
    setAudioDevice() {
      this.$store.commit("SET_AUDIOOUTPUTDEVICEID", this.audioOutputDeviceId);
      this.stopAudioDestination();
      if (this.audioOutputDeviceId != -1) {
        if (!this.audioEl) {
          this.audioEl = new Audio();
        }
        this.audioEl.src = this.audioPlaySrc;
        this.audioEl
          .setSinkId(this.audioOutputDeviceId)
          .then(() => {
            console.log("Audio output set to", this.audioOutputDeviceId);
          })
          .catch(function (error) {
            console.log(error);
          });
        this.audioEl.volume = (this.volume / 100).toFixed(1);
      }
    },
    async changeAudioDestination() {
      // this.stopAudioDestination();

      this.audioEl.play();
      this.audioEl.onended = () => {
        this.isPlaying = false;
        console.log("播放结束");
      };

      this.isPlaying = true;
    },
    async stopAudioDestination() {
      this.isPlaying = false;
      if (this.audioEl) {
        this.audioEl.pause();
        this.audioEl = null;
      }
    },
    changeVolume() {
      if (this.audioEl && this.audioEl.volume) {
        this.audioEl.volume = (this.volume / 100).toFixed(1);
      }
    },
  },
};
</script>

<style  lang="scss">
.check-speaker-btn,
.check-speaker-btn:hover,
.check-speaker-btn:active,
.check-speaker-btn:focus {
  width: 240px;
  height: 40px;
  margin: 28px 0px 70px 0px;
  background-color: $bule-color;
  border: none;
  color: #fff;

  &.active {
    background: $bule-color url(~@/assets/images/volume.gif) no-repeat center;
    background-size: contain;
  }
}
</style>
